var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeSection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1730,
    viewBox: "0 0 1920 1730",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M303.158 1466.39C392.084 1342.33 138.105 1316.76 0 1319.48V0H1920V1319.48C1562.28 1352.55 1476.69 1493.89 1477 1581.8C1477.06 1600 1473.28 1618.94 1460.26 1631.65C1305.2 1783.15 1120.23 1727.47 1040.17 1676.02C1037.2 1674.12 1034.62 1671.77 1032.25 1669.15C919.58 1545.19 685.882 1563.9 576.596 1590.14C572.772 1591.06 569.047 1591.69 565.125 1591.97C437.711 1601.14 215.581 1588.56 303.158 1466.39Z",
    fill: "#DE810E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeSection);
export default __webpack_public_path__ + "static/media/orange_section.a89c1820d5f4cdf67c426d8db746233c.svg";
export { ForwardRef as ReactComponent };